import * as React from "react";

import {IMessageInputState} from "./~types/MessageInputState";
import {IMessageInputProps} from "./~types/MessageInputProps";
import { MIN_MESSAGE_LENGTH, LINE_BREAK, ENTER_KEY, webkitSpeechRecognition } from "./MessageInputConstants";
import EmojiDialog from './emoji-dialog/EmojiDialog';
import i18n from "src/app/shared/localization/i18n";
import Input from "@material-ui/core/Input";
import SendIcon from "@material-ui/icons/Send";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";

import "./MessageInput.css";
import { debug } from "console";
let isVoiceRecording = false;
let isWaitingMicroPermission = false;
let opacityState = "hight";

export default class MessageInput extends React.Component<IMessageInputProps, IMessageInputState> {
    public readonly state: Readonly<IMessageInputState> = {
        messageText: "",
        isReadyToSendPreviewMessage: true
    };
    private speechRecognizer: any;

    private timer: any;

    private inputRef = React.createRef<HTMLInputElement>();

    private urlParams = new URLSearchParams(window.location.href);
    
    private autoSendSpeechRecognizier = this.urlParams.get('autoSendSpeechRecognizier') === "true" ? true : false;

    public componentDidUpdate() {
        this._setChatBodyHeight();
    }

    public _setFocus() {
        const input = this.inputRef.current?.children[0] as HTMLInputElement;
        input.focus();
    }

    public _onEmojiClick (emojiObject: any) {      
        this.setState({messageText: this.state.messageText + emojiObject.native}); 
      };

    public render() {
        const disabledClassName = this.state.messageText.length < MIN_MESSAGE_LENGTH ? "message-input__icon-button--disabled" : "";
        const iconButtonClassName = "send-button message-input__icon-button message-input__icon-button--end " + disabledClassName;
        const urlParams = new URLSearchParams(window.location.search);
        let plHolder = urlParams.has("input_placeholder") ? urlParams.get("input_placeholder")!: i18n.t("chat.enterYourMessage");
        let sendIconButtonClassName = this.state.messageText.length < MIN_MESSAGE_LENGTH ? "send-button-icon" : "send-button-icon active-icon";

        return (
            <Input
                placeholder={plHolder}
                id="textarea"
                type="text"
                ref={this.inputRef}
                spellCheck={true}
                value={this.state.messageText}
                rowsMax={5}
                autoFocus = {true}
                onChange={this._onMessageChangeHandler}
                onPaste={this.props.onInputPasteHandler}
                multiline={true}
                fullWidth={true}
                inputProps = {{ maxLength: 1000 }}
                className="message-input__text"
                endAdornment={                    
                    <InputAdornment position="end">
                        <EmojiDialog onEmojiClick={this._onEmojiClick.bind(this)}></EmojiDialog>
                        {webkitSpeechRecognition ?
                            <img className="mic-button" onClick={() => { this.onVoiceInputActivate(this.onVoiceInputChangeText) }} id="mic-button"></img>
                            :
                            <img></img>}
                        <IconButton
                            edge="end"
                            className={iconButtonClassName}
                            onClick={this._onSendMessageHandler}
                            style={{ backgroundColor: 'transparent'}}
                            disabled={this.state.messageText.length < MIN_MESSAGE_LENGTH || this.props.isSendingMessage}>
                            <div className={sendIconButtonClassName} />
                        </IconButton>
                    </InputAdornment>
                }
                onKeyDown={(event) => {
                    if(event.key === ENTER_KEY && !event.shiftKey){
                        if(this.props.isSendingMessage) {
                            event.preventDefault();
                        }
                        else {
                            this._onSendMessageHandler();
                        }
                    }
                }}
            />
        );
    }

    private _setChatBodyHeight = (): void => {
        setTimeout(() => {
            let inputContainerHeight = document.getElementById('input-container')?.offsetHeight;
            let textareaHeight = document.getElementById('textarea')?.offsetHeight;
            let footerHeight = inputContainerHeight !== undefined && textareaHeight !== undefined ? inputContainerHeight + textareaHeight : 0;
            document.getElementById('chat-body')?.style.setProperty('bottom', footerHeight != 0 ? `${footerHeight}px` : '');
        });
    }

    private _onMessageChangeHandler = (event: React.ChangeEvent<HTMLInputElement>): void => {
        if(event.currentTarget.value[event.currentTarget.value.length - 1] === LINE_BREAK && 
            (this.state.messageText.length < MIN_MESSAGE_LENGTH || (event.currentTarget.value.trim() === ''))){
            return;
        }
        const messageText = event.currentTarget.value;
        this.setState({messageText});

        if(this.state.isReadyToSendPreviewMessage) {
            this.setState({isReadyToSendPreviewMessage: false}, () => this._previewMessageHandler(messageText))
        }
    }; 

    private _previewMessageHandler = (messageText: string) => {
        this.props.onSendPreviewMessage(messageText);
        
        setTimeout(() => {
            if(messageText != this.state.messageText) {
                this._previewMessageHandler(this.state.messageText);
            }
            else this.setState({isReadyToSendPreviewMessage: true})
        }, 3000)
    }

    private _onSendMessageHandler = (): void => {
        if(this.state.messageText.length < MIN_MESSAGE_LENGTH || this.state.messageText.trim() === ''){
            return;
        }       
        this.props.onSendMessage(this.state.messageText);
        this.setState({messageText: ""});
        this.setState({ isReadyToSendPreviewMessage: false }, () => this._previewMessageHandler(""))
    };

    private onVoiceInputChangeText = (textFromSpeechRecognizer: string): void => {
        this.setState({ messageText: textFromSpeechRecognizer });
    };

    private setMicrophoneOpacity = (): void => {
        let element = document.getElementById("mic-button");
        if(element) {
            if(opacityState == "low") {
                element.style.opacity = "1";
                opacityState = "hight";
            }
            else {
                element.style.opacity = "0.3";
                opacityState = "low";
            }
        }
    };
    
    private onVoiceInputActivate = (onVoiceInputChangeText: Function): void => {
        let element = document.getElementById("mic-button");

        if(!isVoiceRecording && !isWaitingMicroPermission) {
            
            isWaitingMicroPermission = true;
            const oldMessage = this.state.messageText;
            
            this.speechRecognizer = new webkitSpeechRecognition();
            this.speechRecognizer.continuous = true;
            this.speechRecognizer.interimResults = true;
            this.speechRecognizer.maxAlternatives = 1;
            this.speechRecognizer.lang = "ru-RU"

            let textArea = document.getElementById("textarea");

            let id: NodeJS.Timeout;

            //Fires only after permission granted
            this.speechRecognizer.onstart = (event: any) => {
                let element = document.getElementById("mic-button");
        
            element?.setAttribute("class", "mic-button-recording");

                id = setInterval(this.setMicrophoneOpacity, 1000);

                isWaitingMicroPermission = false;
                isVoiceRecording = true;
            }

            this.speechRecognizer.onend = (event: any) => {
                isWaitingMicroPermission = false;
            }

            this.speechRecognizer.onresult = (event: any) => {
                if(textArea) {
                  textArea.scrollTop = textArea.scrollHeight;
                }        
                let viResult = event.results[event.resultIndex];
                if (oldMessage !== undefined && oldMessage.length < 1) {
                    onVoiceInputChangeText(viResult[0].transcript);
                } else {
                    onVoiceInputChangeText(oldMessage + " " + viResult[0].transcript);
                }
                if (viResult.isFinal && this.autoSendSpeechRecognizier && isVoiceRecording) {
                    this.timer = setTimeout(() => {
                        this._onSendMessageHandler();
                        element?.setAttribute("class", "mic-button");
                        isVoiceRecording = false;
                    }, 3000);
                }
            }

            this.speechRecognizer.onaudioend = () => {
                if (!this.autoSendSpeechRecognizier) {
                    element?.setAttribute("class", "mic-button");
                    isVoiceRecording = false;
                }
                if(id)
                {
                clearInterval(id); 
                }
                if(element)
                    element.style.opacity = "unset";
            }
            this.speechRecognizer.start();
        }
        else if(isVoiceRecording) {
            element?.setAttribute("class", "mic-button");
            this.speechRecognizer.stop();
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            isVoiceRecording = false;
        }
    };


}